export const contentTableConfig = {
  title: '付费列表',
  propList: [
    { prop: 'studentName', label: '学生姓名', minWidth: '120' },
    { prop: 'phone', label: '联系电话', minWidth: '120' },
    { prop: 'levelName', label: '学段', minWidth: '100' },
    { prop: 'gradeName', label: '年级', minWidth: '100' },
    { prop: 'subjectName', label: '科目', minWidth: '100' },
    { prop: 'teacherName', label: '老师姓名', minWidth: '120' },
    { prop: 'campusName', label: '校区', minWidth: '120' },
    { prop: 'classroomName', label: '教室', minWidth: '120' },
    { prop: 'appointmentDate', label: '预约日期', minWidth: '120' },
    { prop: 'lessonTime', label: '课程时间', minWidth: '140' },
    { prop: 'status', label: '状态', minWidth: '80', slotName: 'payStatus' },
    { prop: 'option', label: '操作', minWidth: '80', slotName: 'option' }

  ],
  showSelectColumn: false
} 